// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-title {
  font-size: 14px;
  text-align: center;
  margin: 9px 0;
  width: 100%;
  display: block;
}

.container-numeric-keypad {
  height: 260px;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-request-numeric-password/popup-request-numeric-password.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;AACJ","sourcesContent":[".label-title {\n    font-size: 14px;\n    text-align: center;\n    margin:  9px 0;\n    width: 100%;\n    display: block;\n}\n\n.container-numeric-keypad{\n    height: 260px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
